<template>
  <section class="gh-form-registration-summit gh-form-registration-summit-upgrade">
    <gh-update-header/>
    <div id="registration" class="gh-summit-section pt-1 gh-form--registration" v-loading.fullscreen.lock="isProcessing"
         element-loading-text="We're processing your upgrade...">
      <div class="gh-form__wrapper container">
        <h4 class="section-heading gh-heading">Upgrade your registration - and enjoy extra perks!</h4>
        <p class="gh-subheading">By upgrading, you'll get extended access to all video recordings until 6 November. You
          will also be able to download session slides & post-session notes.</p>
        <el-form
            :model="form"
            :rules="form.validationRules"
            status-icon
            @keyup.enter.native="attemptSubmit('elForm')"
            ref="elForm"
            class="gh-form">
          <div class="gh-form__section">
            <el-row :gutter="innerGutter">
              <el-col :xs="24">
                <el-form-item prop="email">
                  <label class="gh-form__label">Enter your registration email</label>
                  <el-input v-model="form.email" type="email" name="email"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
              </el-col>
            </el-row>

          </div>

          <!-- TnC -->
          <div class="tnc">
            <p class="gh-form__heading">Amount payable: <span class="gh-price"> <span class="gh-dollar-sign">£</span>10</span>
            </p>
            <el-form-item prop="accept">
              <el-checkbox v-model="form.accept" class="term-checkbox">
                Please charge <span class="gh-dollar-sign">£</span>10 to upgrade my registration as per event <a
                  @click="dialogVisible = true">Terms and Conditions.</a>
              </el-checkbox>
            </el-form-item>
          </div>

          <vue-recaptcha
              ref="recaptcha"
              :sitekey="recaptchaSitekey"
              size="invisible"
              badge="bottomleft"
              :loadRecaptchaScript="true"
              @verify="setRecaptchaToken"/>

          <!-- Actions -->
          <div class="gh-form__actions mt-1">
            <el-button
                class="gh-button--summit gh-button-registration border-none bg-pink bg-hover-light-pink text-white mt-1"
                @click="attemptSubmit('elForm')" :disabled="isProcessing">
              Upgrade Now
            </el-button>
          </div>
        </el-form>
      </div>
    </div>
    <gh-term :visible="dialogVisible" :width="dialogWidth" @hide="dialogVisible=false"/>
  </section>
</template>

<script>
import registrationMixin from '@/modules/registration/mixins/registration'
import Form from '@/modules/form/models/Form'
import ghTerm from '@/modules/events/suicidePreventionSummit/components/Term'
import ghUpdateHeader from '@/modules/events/suicidePreventionSummit/components/UpgradeHeader'

export default {
  mixins: [registrationMixin],

  components: {
    ghTerm,
    ghUpdateHeader
  },

  data() {
    return {
      dialogVisible: false,
      isProcessing: false,
      form: new Form({
        email: '',
        accept: false,
        recaptcha: '',
        cardName: '',
      }),
    }
  },

  computed: {
    innerGutter() {
      return this.device === 'mobile' ? 0 : 30
    },

    dialogWidth() {
      return this.device !== 'widescreen' ? '85%' : '50%'
    },

    device() {
      return this.$store.getters['ui/getDevice']
    },
    stripeStyles() {
      return {}
    },
  },
  methods: {
    setRecaptchaToken(token) {
      this.form.recaptcha = token
    }
  }
}
</script>
<style lang="scss" scoped>
.el-button {
  padding: 1.1rem 2.7rem;
}

.gh-button--summit {
  &:active {
    color: white;
  }

  &focus {
    color: white;
    background: #f76c6c;
  }
}

.el-button:focus, .el-button:hover {
  color: white;
  border-color: #f19999;
  background-color: #f19999;
}

.gh-form {
  max-width: 700px;
  margin: auto;
}

.gh-form__section {
  margin-bottom: 0;
  padding-bottom: 0;
}

.gh-form__actions {
  @media (max-width: 767px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.gh-heading {
  text-align: center;
  font-weight: 600;
}

.gh-payment-hint {
  margin-top: -.5rem;
  margin-bottom: -1.5rem;
  text-align: right;
}

.gh-subheading {
  font-size: 1.3rem;
  max-width: 932px;
  margin: auto;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 600;
}

.gh-form__heading {
  font-size: 1.6rem;
  margin-bottom: 20px;
}

.gh-form__label {
  font-weight: 600;
  font-size: 1.05rem;
}

.gh-price {
  font-weight: 600;
  font-size: 2rem;
  color: #F76B6B;
}

.term-checkbox {
  font-weight: 500;
  display: flex;
  align-items: flex-start;

  a {
    text-decoration: underline;
  }
}

.gh-button {
  font-size: 1.1rem;
  font-weight: 700;
}

.gh-dollar-sign {
  font-family: freight-sans-pro, sans-serif !important;
}

.tnc {
  a {
    color: #474F59;
  }
}
</style>

<style lang="scss">
.gh-form-registration-summit-upgrade {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-input {
    padding-top: 5px;
    padding-bottom: 5px;

    .el-input__inner {
      background: white;
      font-size: 1.1rem;
      height: 52px !important;
      border-color: #E6E6E6;
    }
  }

  .ElementsApp .InputElement {
    font-size: 15px;
    color: #A0A4A9 !important;
  }

  .term-checkbox {
    .el-checkbox__label {
      font-size: 1.05rem;
    }
  }

  @media screen and (max-width: 767px) {
    .el-radio-group {
      .gh-row-radio-group {
        flex-flow: column;
      }

      .gh-col-radio-group {
        + .gh-col-radio-group {
          margin-top: 2rem;
        }
      }
    }
  }
}
</style>
